import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  metaMaskWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { defineChain } from "viem";
import { createConfig, http } from "wagmi";

const getConnectors = () => {
  if (typeof window === "undefined") {
    return [];
  }

  return connectorsForWallets(
    [
      {
        groupName: "Recommended",
        wallets: [metaMaskWallet, walletConnectWallet],
      },
    ],
    {
      appName: "VOM",
      projectId: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID || "",
    },
  );
};

const krownChain = defineChain({
  id: 1983,
  name: "Krown",
  network: "krown",
  nativeCurrency: {
    decimals: 18,
    name: "Krown",
    symbol: "KROWN",
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.krown.network"],
    },
    public: {
      http: ["https://mainnet.krown.network"],
    },
  },
});

const krownTestnetChain = defineChain({
  id: 89127398,
  name: "Krown Testnet",
  network: "krown",
  nativeCurrency: {
    decimals: 18,
    name: "Krown",
    symbol: "KROWN",
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.krown.network"],
    },
    public: {
      http: ["https://testnet.krown.network"],
    },
  },
  blockExplorers: {
    default: {
      name: "Krown Testnet Explorer",
      url: "https://explorer-testnet.krown.network/",
    },
  },
});

const isProduction = false; // Set to true for production, false for development
// console.log(
//   "Wagmi config initialized with chain:",
//   isProduction ? "Krown Mainnet" : "Krown Testnet",
// );

export const config = isProduction
  ? createConfig({
    connectors: getConnectors(),
    chains: [krownChain],
    transports: {
      [krownChain.id]: http(),
    },
    ssr: false,
  })
  : createConfig({
    connectors: getConnectors(),
    chains: [krownTestnetChain],
    transports: {
      [krownTestnetChain.id]: http(),
    },
    ssr: false,
  });
